/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Player_DecksInputs */



/**
* | output |
* | --- |
* | "Player Decks" |
*
* @param {Decks_Player_DecksInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_player_decks = /** @type {((inputs?: Decks_Player_DecksInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Player_DecksInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decks des joueurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Decks de jugadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Decks dos Jogadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Deck dei Giocatori")
	return /** @type {LocalizedString} */ ("Player Decks")
});